export type BadgeVariant = 'green' | 'yellow' | 'red' | 'gray' | 'blue';

export interface StatusBadgeProps {
  label: string;
  variant?: BadgeVariant;
}

const variantClasses: Record<BadgeVariant, string> = {
  green: 'bg-emerald-50 text-emerald-700',
  yellow: 'bg-amber-50 text-amber-700',
  red: 'bg-red-50 text-red-700',
  gray: 'bg-slate-100 text-slate-600',
  blue: 'bg-sky-50 text-sky-700',
};

export function StatusBadge({ label, variant = 'gray' }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${variantClasses[variant]}`}
    >
      {label}
    </span>
  );
}
